<script lang="ts">
export default {
  name: "Footer",
  props: {
    prospectManager: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      userInformation: null as unknown as ComputedRef<any>,
    };
  },
  async created() {
    this.userInformation = computed(() => useUser().getUserInformation());
  },
};
</script>

<template>
  <v-footer class="d-flex justify-end flex-column pa-0 v-footer">
    <v-card class="mb-0 pa-4 footer-wrapper">
      <v-card-subtitle class="text-left footer-subtitle">
        <span class="contact-hours">{{ $t("footer.contactHours") }}</span>
        <span class="contact-phone">
          <a :href="`tel:${$t('footer.contactPhone')}`">{{
            $t("footer.contactPhone")
          }}</a>
        </span>
      </v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" md="6" class="align-self-center">
            <!-- first block -->
            <div class="d-flex align-center">
              <v-icon class="mr-5" color="#E05C91" size="40">
                mdi-account-tie
              </v-icon>
              <div class="flex-column">
                <div class="font-weight-bold">
                  {{ $t("footer.relationshipManagerLabel") }}
                </div>
                <div>{{ prospectManager?.managerName }}</div>
                <div class="contact-phone">
                  <a :href="`tel:${prospectManager?.phoneNumber}`">{{
                    prospectManager?.phoneNumber
                  }}</a>
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="align-self-center">
            <!-- second block -->
            <NuxtLink
              class="no-decoration d-inline-block"
              to="https://www.cimbanque.com/fr/the-bank/contact-us/"
              target="_blank"
            >
              <div class="d-inline-flex align-center">
                <v-icon class="mr-5" color="#E05C91" size="40"
                  >mdi-email-outline</v-icon
                >
                <div class="flex-column">
                  <div class="font-weight-bold">
                    {{ $t("footer.contactFormLabel") }}
                  </div>
                  <div style="max-width: 300px">
                    {{ $t("footer.contactFormSubtitle") }}
                  </div>
                </div>
              </div>
            </NuxtLink>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <div class="py-2 text-center">
      {{ $t("footer.copyright") }}
    </div>
  </v-footer>
</template>

<style scoped lang="scss">
@import "@/assets/css/variables.scss";

.v-footer {
  background-color: transparent;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
}

.footer-wrapper {
  opacity: 1;
  width: 100%;
  background: rgba(255, 255, 255, 0.7);
}

.footer-subtitle {
  opacity: 1;
}

.contact-hours {
  color: #aaa;
  margin-right: 10px;

  @media only screen and (max-width: 600px) {
    display: block;
  }
}

.contact-phone {
  font-weight: bold;

  a:link,
  a:visited,
  a:hover,
  a:active {
    text-decoration: none;
    color: $cim-pink;
  }
}

.no-decoration {
  text-decoration: none;
  color: inherit;
}
</style>
